// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-preview[data-v-4f8d0cf1] {\n  pointer-events: none;\n  cursor: default !important;\n}\n.is-preview *[data-v-4f8d0cf1] {\n  pointer-events: none;\n  cursor: default !important;\n}\n.multiselect-econtador[data-v-4f8d0cf1] {\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
